// import axios from "axios";

export const numericValidation = (event) => {
  if (event.key === "Backspace" || event.key === "Delete") {
    return false;
  } else if (!/\d/.test(String.fromCharCode(event.keyCode || event.which))) {
    event.preventDefault();
  }
};

export const getLookerUrl = (
  regionLooker,
  assessementId,
  projectType,
  endYear,
  targetScenario
) => {
  let lookerURL = "";
  switch (regionLooker) {
    case "Australia":
      lookerURL = `https://lendlease.cloud.looker.com/embed/dashboards/96?Assessment+Name=${assessementId}&Region+P=${regionLooker}&Typologies+P=${projectType}&End+Year+P=${endYear}&Scenario+P=${targetScenario}&allow_login_screen=true&theme=sustainability`;
      break;
    case "United States":
      lookerURL = `https://lendlease.cloud.looker.com/embed/dashboards/94?Assessment+Name=${assessementId}&Region+P=United+States&Typologies+P=${projectType}&End+Year+P=${endYear}&Scenario+P=${targetScenario}&allow_login_screen=true&theme=sustainability`;
      break;
    case "Asia":
      lookerURL = `https://lendlease.cloud.looker.com/embed/dashboards/94?Assessment+Name=${assessementId}&Region+P=${regionLooker}&Typologies+P=${projectType}&End+Year+P=${endYear}&Scenario+P=${targetScenario}&allow_login_screen=true&theme=sustainability`;
      break;
    case "Europe":
      lookerURL = `https://lendlease.cloud.looker.com/embed/dashboards/98?Assessment+Name=${assessementId}&Region+P=${regionLooker}&Typologies+P=${projectType}&End+Year+P=${endYear}&Scenario+P=${targetScenario}&allow_login_screen=true&theme=sustainability`;
      break;
  }
  return lookerURL;
};
